import Vue from 'vue';

export default Vue.directive('openLinksInNewTab', {
  componentUpdated(el) {
    [...el.getElementsByTagName('a')].forEach((a) => {
      a.target = '_blank'; // eslint-disable-line no-param-reassign
    });
  },
});
